import { resetData } from "../../features/login/LoginSlice";
import { useDispatch } from "react-redux";
import { saveCartId } from "../../features/Cart/CartSlice";
import { useNavigate } from "react-router-dom";
import { setCompareListId } from "../../features/CompareList/CompareListSlice";
import { resetViewData } from "../../features/recentlyView/RecentlyViewSlice";

export const useAccountDropDown = (props = {}) => {
  const { handleAccountTrigger } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const MENU_ITEMS = [
    {
      name: "My Account",
      url: "/account-information",
    },
    {
      name: "My Cart",
      url: "/cart",
    },
    {
      name: "My Wishlist",
      url: "/wishlist",
    },
    {
      name: "My Orders",
      url: "/order-history",
    },
  ];

  const handleLogout = () => {
    try {
      handleAccountTrigger();
      dispatch(resetData());
      dispatch(saveCartId(""));
      dispatch(setCompareListId(""));
      dispatch(resetViewData());
      navigate("/");
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error(error);
      }
    }
  };

  return {
    menuItems: MENU_ITEMS,
    handleLogout,
  };
};
